import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
LicenseManager.setLicenseKey(
  'CompanyName=Lifecycles,LicensedGroup=PIQET,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-036626,SupportServicesEnd=11_January_2024_[v2]_MTcwNDkzMTIwMDAwMA==c7c743c72b8b29abd55918489cbeaec3'
);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
